"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var CannibalizationItem_1 = require("../model/CannibalizationItem");

var WindowPromoEffect_1 = require("../model/WindowPromoEffect");

var WindowPromoEffectBase_1 = require("../model/WindowPromoEffectBase");

var WindowPromoEffectConverter_1 = require("./WindowPromoEffectConverter");
/**
 * Default implementation of WindowPromoEffectConverter.
 *
 * @author VSm
 * @author SMi
 * @author VRu
 */


var WindowPromoEffectConverterImpl =
/*#__PURE__*/
function (_WindowPromoEffectCon) {
  _inherits(WindowPromoEffectConverterImpl, _WindowPromoEffectCon);

  function WindowPromoEffectConverterImpl() {
    _classCallCheck(this, WindowPromoEffectConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowPromoEffectConverterImpl).apply(this, arguments));
  }

  _createClass(WindowPromoEffectConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new WindowPromoEffect_1.WindowPromoEffect(WindowPromoEffectBase_1.WindowPromoEffectBase.schema.id.valueOf(conversions.documentToClassId(source)), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.products.valueOf(source.products.map(function (id) {
        return conversions.toClassReferenceId(id);
      })), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.userTotalAmounts.valueOf(source.userTotalAmounts.map(function (item) {
        return conversions.toBigNumber(item);
      })), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.positiveIncrementAmounts.valueOf(source.positiveIncrementAmounts.map(function (item) {
        return conversions.toBigNumber(item);
      })), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.postPromoAmounts.valueOf(source.postPromoAmounts.map(function (item) {
        return conversions.toBigNumber(item);
      })), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.postPromoDates.valueOf(source.postPromoDates.map(function (item) {
        return conversions.toDate(item);
      })), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.baselineProducts.valueOf(source.baselineProducts.map(function (id) {
        return conversions.toClassReferenceId(id);
      })), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.baselineAmounts.valueOf(source.baselineAmounts.map(function (item) {
        return conversions.toBigNumber(item);
      })), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.cannibalization.valueOf(source.cannibalization.map(function (c) {
        return CannibalizationItem_1.CannibalizationItem.deserializeCannibalizationItem(c, conversions);
      })), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.dailyTotals.valueOf(utils_1.Utils.asArray(source.dailyTotals).map(function (a) {
        return utils_1.Utils.asArray(a).map(function (n) {
          return conversions.toBigNumber(n);
        });
      })), WindowPromoEffectBase_1.WindowPromoEffectBase.schema.historic.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        windowId: conversions.toDocumentReferenceId(source.windowId),
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        products: source.products.map(function (item) {
          return conversions.toDocumentReferenceId(item);
        }),
        userTotalAmounts: source.userTotalAmounts.map(function (item) {
          return conversions.fromBigNumber(item);
        }),
        positiveIncrementAmounts: source.positiveIncrementAmounts.map(function (item) {
          return conversions.fromBigNumber(item);
        }),
        postPromoAmounts: source.postPromoAmounts.map(function (item) {
          return conversions.fromBigNumber(item);
        }),
        postPromoDates: source.postPromoDates.map(function (item) {
          return conversions.fromDate(item);
        }),
        baselineProducts: source.baselineProducts.map(function (item) {
          return conversions.toDocumentReferenceId(item);
        }),
        baselineAmounts: source.baselineAmounts.map(function (item) {
          return conversions.fromBigNumber(item);
        }),
        cannibalization: source.cannibalization.map(function (c) {
          return CannibalizationItem_1.CannibalizationItem.serializeCannibalizationItem(c, conversions);
        }),
        dailyTotals: source.dailyTotals.map(function (a) {
          return a.map(function (n) {
            return conversions.fromBigNumber(n);
          });
        }),
        historic: source.historic
      });
      return result;
    }
  }]);

  return WindowPromoEffectConverterImpl;
}(WindowPromoEffectConverter_1.WindowPromoEffectConverter);

exports.WindowPromoEffectConverterImpl = WindowPromoEffectConverterImpl;